/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_DeliveredInputs */

const tr_geliver_status_delivered = /** @type {(inputs: Geliver_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim edildi`)
};

const en_geliver_status_delivered = /** @type {(inputs: Geliver_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

const de_geliver_status_delivered = /** @type {(inputs: Geliver_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugestellt`)
};

const ru_geliver_status_delivered = /** @type {(inputs: Geliver_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставлено`)
};

/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Geliver_Status_DeliveredInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_delivered = /** @type {((inputs?: Geliver_Status_DeliveredInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_DeliveredInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_delivered(inputs)
	if (locale === "de") return de_geliver_status_delivered(inputs)
	if (locale === "ru") return ru_geliver_status_delivered(inputs)
	return tr_geliver_status_delivered(inputs)
});